import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

const dealershipRequest = (data) => ({
  ...(data || {}),
  requestedApp: 'dealership_web',
});

const callableError = (error, message) => {
  notifyPermissionDenied(error);
  return { success: 'no', message, error: error.message };
};

export const createCar = async (data) => {
  try {
    const fn = httpsCallable(functions, 'createCarV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error creating car:', error);
    return callableError(error, 'Error al crear el auto');
  }
};

export const updateCar = async (data) => {
  try {
    const fn = httpsCallable(functions, 'updateCarV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error updating car:', error);
    return callableError(error, 'Error al actualizar el auto');
  }
};

export const getDealershipCars = async (data) => {
  try {
    const fn = httpsCallable(functions, 'getDealershipCarsV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error getting cars:', error);
    return callableError(error, 'Error al obtener los autos');
  }
};

export const deleteCar = async (data) => {
  try {
    const fn = httpsCallable(functions, 'deleteCarV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error deleting car:', error);
    const blocked = error.code === 'functions/failed-precondition' || error.code === 'failed-precondition';
    return callableError(error, blocked ? error.message : 'Error al eliminar el auto');
  }
};
